<template>
  <router-view />
</template>

<style lang="scss">
@import "./assets/style/index.scss";
</style>
